module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticesBackToBack.png
// module id = 2367
// module chunks = 2